import type { ReactNode } from "react";

export interface ServicePurchaseNewViewProps {
  /**
   * The wired guest purchase flow (email-capture → free-success modal). It is a
   * connected child — Inertia form + routed modal — so the container wires it up
   * and hands it in here.
   */
  children: ReactNode;
}

/**
 * Presentational shell for the service purchase modal route. The purchase flow
 * itself is connected (Inertia form state + routed modal), so it is composed in
 * the container and passed in as `children`; this view simply renders it.
 */
export function ServicePurchaseNewView({ children }: ServicePurchaseNewViewProps) {
  return <>{children}</>;
}
